import React from 'react';
import IconNext from '@/assets/IconRight.svg';
import IconPrev from '@/assets/IconLeft.svg';

import { IButtonsSliderAreasProps } from './interface';

export const ButtonSlider = ({
  handleClick,
  sliderScroll,
  checkScrollLimit,
}: IButtonsSliderAreasProps) => {
  return (
    <div className="vitrine-template2__buttons--slider">
      <button
        type="button"
        onClick={() => handleClick('left')}
        disabled={sliderScroll <= 0}
        className="vitrine-template2__buttons--left"
        data-testid="prev"
      >
        <img src={IconPrev} alt="Anterior" />
      </button>

      <button
        type="button"
        onClick={() => handleClick('right')}
        disabled={checkScrollLimit(sliderScroll)}
        className="vitrine-template2__buttons--right"
        data-testid="next"
      >
        <img src={IconNext} alt="Próximo" />
      </button>
    </div>
  );
};
